import { Users, Code, Megaphone, Palette, Network } from "lucide-react";
import { PortalLayout } from "../components/PortalLayout";

const partnerAreas = [
  { area: "Software Development & Engineering", icon: Code, description: "Specialised software engineering and technical development execution across all platforms." },
  { area: "Marketing & Brand Positioning", icon: Megaphone, description: "Strategic marketing, brand development, and communications support for platform launches and growth." },
  { area: "UX/UI Design & Technical Implementation", icon: Palette, description: "User experience design, interface development, and technical implementation services." },
  { area: "Network Infrastructure & Support Services", icon: Network, description: "Network infrastructure management, connectivity solutions, and technical support operations." },
];

const layers = [
  { num: "1", label: "Owned Platforms", desc: "Direct ownership and operation of core platforms (AutoGuard, MyCash, Life Happens, GetMePrinting)", color: "bg-[#7B1A1A]" },
  { num: "2", label: "Licensed Solutions", desc: "Distribution and support of partner technologies (FPI, BOS, LSD, PICME, EvidenceWeb)", color: "bg-[#1F2933]" },
  { num: "3", label: "Partner Entities", desc: "Independent but aligned entities providing development, marketing, design, and infrastructure services", color: "bg-[#4B5563]" },
];

export function PartnerEcosystemPage() {
  return (
    <PortalLayout>

      {/* Header */}
      <div className="mb-14">
        <div className="flex items-center gap-3 mb-4">
          <Users className="w-5 h-5 text-[#7B1A1A]" />
          <p className="text-xs font-semibold uppercase tracking-widest text-[#7B1A1A]">
            Partner Ecosystem
          </p>
        </div>
        <h1 className="text-2xl sm:text-4xl md:text-5xl font-semibold text-[#1F2933] mb-8 leading-tight max-w-3xl">
          Strategically Aligned Partner Entities
        </h1>
        <p className="text-[#4B5563] max-w-4xl leading-relaxed">
          LEO Group works with a network of strategically aligned partner entities that are partially or fully owned
          by LEO Group but operate as independent businesses. These entities provide specialised services including
          development, marketing, design, and infrastructure support.
        </p>
      </div>

      {/* Info */}
      <div className="bg-[#FDEAE0]/60 border border-[#7B1A1A]/15 rounded-lg p-6 mb-14">
        <p className="text-sm text-[#4B5563] leading-relaxed">
          These partners operate independently with their own governance structures while maintaining strategic
          alignment with LEO Group's platform and infrastructure initiatives.
        </p>
      </div>

      {/* Partners Grid */}
      <div className="mb-14">
        <h2 className="text-xl font-semibold text-[#1F2933] mb-8">Strategic Partner Capabilities</h2>
        <div className="grid md:grid-cols-2 gap-6">
          {partnerAreas.map(({ area, icon: Icon, description }) => (
            <div
              key={area}
              className="bg-white border border-[#E5E7EB] rounded-lg p-6 shadow-sm hover:border-[#7B1A1A]/30 transition-colors"
            >
              <div className="flex items-start gap-4 mb-3">
                <Icon className="w-7 h-7 text-[#7B1A1A] flex-shrink-0" />
                <h3 className="text-sm font-semibold text-[#1F2933] leading-snug">{area}</h3>
              </div>
              <p className="text-sm text-[#4B5563] leading-relaxed pl-11">{description}</p>
            </div>
          ))}
        </div>
      </div>

      {/* Three-Layer Structure */}
      <div className="bg-white border border-[#E5E7EB] rounded-lg p-8 shadow-sm mb-14">
        <h3 className="text-base font-semibold text-[#1F2933] mb-8">Three-Layer Ecosystem Structure</h3>
        <div className="space-y-6">
          {layers.map((layer) => (
            <div key={layer.num} className="flex gap-5">
              <div className={`w-8 h-8 ${layer.color} rounded-full flex items-center justify-center text-white text-sm font-semibold flex-shrink-0`}>
                {layer.num}
              </div>
              <div>
                <h4 className="text-sm font-semibold text-[#1F2933] mb-1">{layer.label}</h4>
                <p className="text-sm text-[#4B5563] leading-relaxed">{layer.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>


    </PortalLayout>
  );
}
